__turbopack_context__.v({
  "body": "XxyHhW_body",
  "buttonSkeleton": "XxyHhW_buttonSkeleton",
  "cardSkeleton": "XxyHhW_cardSkeleton",
  "footer": "XxyHhW_footer",
  "imageSkeleton": "XxyHhW_imageSkeleton",
  "leftWrapper": "XxyHhW_leftWrapper",
  "rightWrapper": "XxyHhW_rightWrapper",
  "textSkeleton": "XxyHhW_textSkeleton",
});
